export enum AuthenticationAnalyticsEvents {
  LoginSuccess = 'login_success',
  ExtensionBackButtonPressed = 'ext_back_btn_pressed',
  LogoutSuccess = 'logout_success',
  PbxSelected = 'pbx_selected',
  PbxSwitched = 'pbx_switched',
  CallSupportClicked = 'call_support_clckd',
  EmailSupportClicked = 'email_support_clckd',
}
